export default {
    init() {
        this.bidQuickPriceButton();
    },

    bidQuickPriceButton() {
        $('.product-card--bid-form-buttons .bid-button').on('click',function(){
            let input = $(this).parent().parent().find('.product-card--bid-form .form-input');
            input.val($(this).val());
        });
    },
}